import useSplitedTableByColumn from '../../../hooks/useSplitedTableByColumn';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const _tables = [
  {
    name: 'VaR',
    key: 'var',
    order: 184,
    columnLables: {
      var_value: {
        name: 'VaR Value',
        letter: 'A'
      },
      var_calculation_method: {
        name: 'Calculation method',
        letter: 'B'
      },
      risk_measure_description: {
        name: 'Risk measure description',
        letter: 'C'
      }
    }
  }
];

export function Var({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useSplitedTableByColumn({
    data: funds[currentDataKey]?.fund_data?.VAR_RISK_MEASURE,
    onChangeFund,
    schema: schema.VAR_RISK_MEASURE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.VAR_RISK_MEASURE?.field_names || [],
    tableName: 'VAR_RISK_MEASURE',
    isMultiFunds,
    funds,
    tables: _tables,
    isSingleData: true
  });

  return (
    <StyledTables id="fca-reporttables-var-group">
      {tables.map((rows, index) => (
        <Table
          id={`fca-reporttables-var-table-${index + 1}`}
          key={index + 'VAR_RISK_MEASURE'}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
        />
      ))}
    </StyledTables>
  );
}
